import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContextProvider, LoaderContext } from "../../AuthContext/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Tooltip } from "@mui/material";
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import {
  PrasadCategoryLookupList,
  PrasadDataList,
} from "../../ApiServices/Prasad/PrasadApi";
import Select from "react-select";
import Breadcrumbs from "../Breadcrumb";
import { customSelectStyles } from "../../middlewares/Utils";
import { TempleLookUpList } from "../../ApiServices/Temple/TempleApi";
import { AddUpdateRemoveCart, GetProductCatLookupList } from "../../ApiServices/EStore/EStoreApi";
import NoResultFoundModel from "../NoDataFound/NoDataFoundModal";
import { t } from "i18next";
import LoginPopUp from "../LoginPopup";

const PrasadList = () => {
  const userKeyID = localStorage.getItem("userKeyID");
  const { isAuthenticated } = useContext(AuthContextProvider);
  const scrollRefs = useRef({});
  const navigate = useNavigate()
  const location = useLocation()

  const [totalRecords, setTotalRecords] = useState(-1);
  const { setLoader, selectedLanguageID, setIsCartUpdate, pujaStatus, formatToIndianCurrency } = useContext(LoaderContext);

  const [loginPopUp, setLoginPopUp] = useState(null);
  const [isOnlineSelected, setIsOnlineSelected] = useState(false);
  const [productList, setProductList] = useState([]);
  const [categories, setCategories] = useState([])

  const [selectedCategory, setSelectedCategory] = useState(null)
  const [isCatUpdated, setIsCatUpdated] = useState(false)

  useEffect(() => {
    GetProductCatLookupListData()

  }, [])



  // -------------------API Calling----------------


  const GetProductCatLookupListData = async (selectedCategory) => {

    setLoader(true);
    try {
      const response = await GetProductCatLookupList(selectedCategory, location?.state?.ID, Number(selectedLanguageID), userKeyID);

      if (response?.statusCode === 200) {
        const list = response?.responseData?.data
        setProductList(list);
        setTotalRecords(list?.length);
        setLoader(false);
      } else {
        setLoader(false);
        setTotalRecords(0);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  // ----------------------------------Other Functions---------------------------------

  const viewDetail = (product) => {
    const newSlug = product?.productSlug;
    if (selectedCategory) {
      sessionStorage.setItem("selectedProductCatId", selectedCategory);
    }
    navigate(`/product-details/${newSlug}`, {
      state: { product: product, templeKeyID: location?.state?.ID },
    });
  };

  const handleCatChange = (category) => {
    setTotalRecords(-1)
    setProductList([])
    setSelectedCategory(category?.productCatKeyID);
    sessionStorage.setItem("selectedProductCatId", category?.productCatKeyID);
    GetProductCatLookupListData(category.productCatKeyID)
  };

  const addProduct = async (product, action) => {
    if (!isAuthenticated) {
      setLoginPopUp(true)
    } else {
      setLoader(true);
      try {
        const response = await AddUpdateRemoveCart({
          cartKeyID: product?.cartKeyID,
          productKeyID: product?.productKeyID,
          userKeyID: userKeyID,
          action: action
        });

        if (response?.statusCode === 200) {
          setLoader(false);
          // toast.success("Product Added to cart.")
          setIsCartUpdate(true)
          GetProductCatLookupListData(selectedCategory)

        } else {
          setLoader(false);

        }


      } catch (error) {
        setLoader(false);
        console.log(error);
      }
    }

  }

  return (
    <>
      <div className="container-fluid my-4">


        <div className="row">


          {/* -------- Puja Grid -------- */}
          <main className="col-md-12 col-12" >
            <div className="row g-2 mt-1 " style={{ maxHeight: "100vh", overflowY: "auto", scrollbarWidth: "none", justifyContent: 'left' }}>
              {productList?.map((product, index) => (
                <div
                  className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4 "


                >
                  <div

                    className="card shadow-sm  rounded-3 h-100 border bolder-dark"
                    style={{ cursor: "pointer", overflow: "hidden" }}

                  >
                    {/* Image Section */}
                    <div className="position-relative" onClick={() => viewDetail(product)}>
                      <img
                        src={product.productImageURL || pandit}
                        alt={product.productName}
                        className="card-img-top"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = pandit;
                        }}
                        style={{
                          height: "150px",
                          objectFit: "contain",
                          borderTopLeftRadius: "12px",
                          borderTopRightRadius: "12px",
                        }}
                      />


                    </div>

                    {/* Card Body */}
                    <div className="card-body p-2 d-flex flex-column">
                      <h6
                        className="card-title fw-bold mb-1"
                        style={{ color: "#8f3246", fontSize: "16px" }}
                      >
                        {product.productName}
                      </h6>

                      {/* <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                                {product.PUJA_TAGLINE || "A powerful ritual description..."}
                                            </p> */}



                      {/* Price & Button */}
                      <div className="mt-auto">
                        <span
                          className="fw-bold"
                          style={{ fontSize: "16px", color: "#000" }}
                        >
                          ₹
                          {
                            formatToIndianCurrency(Math.round(product.productPrice - (product.discountAmtount || 0)))

                          }
                        </span>

                        {product?.cartQuantity > 0 ? (
                          <div
                            className="d-flex justify-content-between align-items-center mt-2 qty-container"

                          >
                            <button
                              onClick={() => addProduct(product, 'update')}
                              className="product-qty"
                            >
                              −
                            </button>
                            <span
                              className="quantity"
                            >
                              {product.cartQuantity}
                            </span>
                            <button
                              onClick={() => addProduct(product, "add")}
                              className="product-qty"
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button
                            className="btn w-100 mt-2 add-to-cart"

                            onClick={() => addProduct(product, "add")}
                          >
                            <span className="blink-text">
                              {t("Add To Cart")}
                            </span>
                          </button>
                        )}



                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} />}
            </div>
          </main>
        </div>
      </div>

      {loginPopUp && (
        <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
      )}
    </>
  );
};

export default PrasadList;
